import { render, staticRenderFns } from "./ChartShimmer.vue?vue&type=template&id=d4700fb4&"
import script from "./ChartShimmer.vue?vue&type=script&lang=js&"
export * from "./ChartShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports